import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Container, Box, Grid, TextField, Typography, FormControl, FormHelperText, InputLabel, Input, InputAdornment, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Toolbar, Hidden  } from '@material-ui/core';

import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

import PropertyMenu from './PropertyMenu' // メニュー

import { useDispatch, useSelector } from 'react-redux';
import {
    setApartment,
    clearApartment,
} from '../stores/apartment'

import Explanation from './Explanation' // メニュー
import MenuList from './MenuList' // メニュー
import GuideHalf from './GuideHalf' // ガイド

import FlowTitle from './FlowTitle' // フロータイトル
import FlowItem from './FlowItem' // フローアイテム
import FlowArrow from './FlowArrow' // フローアロー

import PageExplanation from './PageExplanation' // ページ説明

import PageStep from './PageStep' // ステップ
import PropertyStep from './PropertyStep' // 財産ステップ

import TargetPerson from './TargetPerson' // 相続人
import InheritanceBequest from './InheritanceBequest' // 相続・遺贈

const useStyles = makeStyles((theme) => ({
    text: {
        margin: '8px',
    },
    head: {
        backgroundColor: '#3f51b5',
        color: '#fff'
    },
    number: {
        '& .MuiTypography-colorTextSecondary': {
            color: '#f00'
        }
    },
    required: {
        '& .MuiFormHelperText-root': {
            color: '#f00'
        }
    },
    requiredHelper: {
        color: '#f00'
    },
    listWrap: {
        width: '100%',
        marginTop: '10px'
    },
    center: {
        textAlign: 'center'
    },
    cellButton: {
        width: '15%'
    }
}));

// マンション
function Apartment(){
    const dispatch = useDispatch();

    const igonFlag = useSelector(state => state.igon.igonFlag);
    const apartment = useSelector(state => state.apartment.apartment);
    const heiress = useSelector(state => state.heiress.heiress);

    const [error, setError] = useState(null);

    const handleApartment = (event) => {
        const whereabouts = document.getElementById('apartment_whereabouts').value;
        const buildingName = document.getElementById('apartment_building_name').value;
        const houseNumber1 = document.getElementById('apartment_house_number_1').value;
//        const houseNumber = document.getElementById('apartment_house_number').value;
        const proprietaryPartBuildingName = document.getElementById('apartment_proprietary_part_building_name').value;
        const type = document.getElementById('apartment_type').value;
        const construction = document.getElementById('apartment_construction').value;
        const floorSpace = document.getElementById('apartment_floor_space_1').value;
        const landCode = document.getElementById('apartment_land_code').value;
        const locationLotNumber = document.getElementById('apartment_location_lot_number').value;
        const ground = document.getElementById('apartment_ground').value;
        const realEstate = document.getElementById('apartment_real_estate').value;
        const siteRightLandCode = document.getElementById('apartment_site_right_land_code').value;
        const siteRightType = document.getElementById('apartment_site_right_type').value;
        const siteRightPercentage = document.getElementById('apartment_site_right_percentage').value;

        if(whereabouts == ''){
            checkWhereabouts(true);
            whereaboutsHelper('所在は必ずご入力くさだい。');
            setError('エラーが発生しました。所在は必ずご入力くさだい。');
            return;
        }else if(buildingName == ''){
            checkBuildingName(true);
            buildingNameHelper('建物の名称は必ずご入力くさだい。');
            setError('エラーが発生しました。建物の名称は必ずご入力くさだい。');
            return;
        }else if(houseNumber1 == ''){
            checkHouseNumber1(true);
            houseNumber1Helper('家屋番号は必ずご入力くさだい。');
            setError('エラーが発生しました。家屋番号は必ずご入力くさだい。');
            return;
//        }else if(houseNumber == ''){
//            checkHouseNumber(true);
//            houseNumberHelper('家屋番号は必ずご入力くさだい。');
//            return;
        }else if(proprietaryPartBuildingName == ''){
            checkProprietaryPartBuildingName(true);
            proprietaryPartBuildingNameHelper('建物の名称は必ずご入力くさだい。');
            setError('エラーが発生しました。建物の名称は必ずご入力くさだい。');
            return;
        }else if(type == ''){
            checkType(true);
            typeHelper('種類は必ずご入力くさだい。');
            setError('エラーが発生しました。種類は必ずご入力くさだい。');
            return;
        }else if(construction == ''){
            checkConstruction(true);
            constructionHelper('構造は必ずご入力くさだい。');
            setError('エラーが発生しました。構造は必ずご入力くさだい。');
            return;
        }else if(floorSpace == ''){
            checkFloorSpace(true);
            floorSpaceHelper('床面積は必ずご入力くさだい。');
            setError('エラーが発生しました。床面積は必ずご入力くさだい。');
            return;
        }else if(landCode == ''){
            checkLandCode(true);
            landCodeHelper('土地の符号は必ずご入力くさだい。');
            setError('エラーが発生しました。土地の符号は必ずご入力くさだい。');
            return;
        }else if(locationLotNumber == ''){
            checkLocationLotNumber(true);
            locationLotNumberHelper('所在地及び地番は必ずご入力くさだい。');
            setError('エラーが発生しました。所在地及び地番は必ずご入力くさだい。');
            return;
        }else if(ground == ''){
            checkGround(true);
            groundHelper('地目は必ずご入力くさだい。');
            setError('エラーが発生しました。地目は必ずご入力くさだい。');
            return;
        }else if(realEstate == ''){
            checkRealEstate(true);
            realEstateHelper('地積は必ずご入力くさだい。');
            setError('エラーが発生しました。地積は必ずご入力くさだい。');
            return;
        }else if(siteRightLandCode == ''){
            checkSiteRightLandCode(true);
            siteRightLandCodeHelper('土地の符号は必ずご入力くさだい。');
            setError('エラーが発生しました。土地の符号は必ずご入力くさだい。');
            return;
        }else if(siteRightType == ''){
            checkSiteRightType(true);
            siteRightTypeHelper('敷地権の種類は必ずご入力くさだい。');
            setError('エラーが発生しました。敷地権の種類は必ずご入力くさだい。');
            return;
        }else if(siteRightPercentage == ''){
            checkSiteRightPercentage(true);
            siteRightPercentageHelper('敷地権の割合は必ずご入力くさだい。');
            setError('エラーが発生しました。敷地権の割合は必ずご入力くさだい。');
            return;
        }

        let targetPerson = null;
        let inheritanceBequest = null;

        if(igonFlag){
            targetPerson = document.getElementsByName('apartment_target_person')[0].value;
            inheritanceBequest = document.getElementsByName('apartment_inheritance_bequest')[0].value;
            if(igonFlag && targetPerson == ''){
                checkTargetPerson(true);
                targetPersonHelper('取得対象者は必ずご入力くさだい。');
                setError('エラーが発生しました。取得対象者は必ずご入力くさだい。');
                return;
            }else if(inheritanceBequest == ''){
                checkInheritanceBequest(true);
                inheritanceBequestHelper('相続・遺贈は必ずご入力くさだい。');
                setError('エラーが発生しました。相続・遺贈は必ずご入力くさだい。');
                return;
            }

            targetPerson = heiress[targetPerson].name;
        }

        document.getElementById('apartment_whereabouts').value = '';
        document.getElementById('apartment_building_name').value = '';
        document.getElementById('apartment_house_number_1').value = '';
//        document.getElementById('apartment_house_number').value = '';
        document.getElementById('apartment_proprietary_part_building_name').value = '';
        document.getElementById('apartment_type').value = '';
        document.getElementById('apartment_construction').value = '';
        document.getElementById('apartment_floor_space_1').value = '';
        document.getElementById('apartment_land_code').value = '';
        document.getElementById('apartment_location_lot_number').value = '';
        document.getElementById('apartment_ground').value = '';
        document.getElementById('apartment_real_estate').value = '';
        document.getElementById('apartment_site_right_land_code').value = '';
        document.getElementById('apartment_site_right_type').value = '';
        document.getElementById('apartment_site_right_percentage').value = '';

        setWhereaboutsValue(null);
        setBuildingNameValue(null);
        setHouseNumber1Value(null);
//        setHouseNumberValue(null);
        setProprietaryPartBuildingNameValue(null);
        setTypeValue(null);
        setConstructionValue(null);
        setFloorSpaceValue(null);
        setLandCodeValue(null);
        setLocationLotNumberValue(null);
        setGroundValue(null);
        setRealEstateValue(null);
        setSiteRightLandCodeValue(null);
        setSiteRightTypeValue(null);
        setSiteRightPercentageValue(null);

        if(igonFlag){
            setTargetPersonValue(null);
            setInheritanceBequestValue(null);
        }

        const apartment = {
            whereabouts: whereabouts,
            buildingName: buildingName,
            houseNumber1: houseNumber1,
//            houseNumber: houseNumber,
            proprietaryPartBuildingName: proprietaryPartBuildingName,
            type: type,
            construction: construction,
            floorSpace: floorSpace,
            landCode: landCode,
            locationLotNumber: locationLotNumber,
            ground: ground,
            realEstate: realEstate,
            siteRightLandCode: siteRightLandCode,
            siteRightType: siteRightType,
            siteRightPercentage: siteRightPercentage,
            targetPerson: targetPerson,
            inheritanceBequest: inheritanceBequest
        };

        setError('登録しました。');

        dispatch(setApartment(apartment));
    }

    const [whereaboutsValue, setWhereaboutsValue] = useState(null);
    const [buildingNameValue, setBuildingNameValue] = useState(null);
    const [houseNumber1Value, setHouseNumber1Value] = useState(null);
//    const [houseNumberValue, setHouseNumberValue] = useState(null);
    const [proprietaryPartBuildingNameValue, setProprietaryPartBuildingNameValue] = useState(null);
    const [typeValue, setTypeValue] = useState(null);
    const [constructionValue, setConstructionValue] = useState(null);
    const [floorSpaceValue, setFloorSpaceValue] = useState(null);
    const [landCodeValue, setLandCodeValue] = useState(null);
    const [locationLotNumberValue, setLocationLotNumberValue] = useState(null);
    const [groundValue, setGroundValue] = useState(null);
    const [realEstateValue, setRealEstateValue] = useState(null);
    const [siteRightLandCodeValue, setSiteRightLandCodeValue] = useState(null);
    const [siteRightTypeValue, setSiteRightTypeValue] = useState(null);
    const [siteRightPercentageValue, setSiteRightPercentageValue] = useState(null);
    const [targetPersonValue, setTargetPersonValue] = useState(null);
    const [inheritanceBequestValue, setInheritanceBequestValue] = useState(null);

    const handleApartmentEdit = (index, event) => {
        const apartmentEdit = apartment[index];

        setWhereaboutsValue(apartmentEdit.whereabouts);
        setBuildingNameValue(apartmentEdit.buildingName);
        setHouseNumber1Value(apartmentEdit.houseNumber1);
//        setHouseNumberValue(apartmentEdit.houseNumber);
        setProprietaryPartBuildingNameValue(apartmentEdit.proprietaryPartBuildingName);
        setTypeValue(apartmentEdit.type);
        setConstructionValue(apartmentEdit.construction);
        setFloorSpaceValue(apartmentEdit.floorSpace);
        setLandCodeValue(apartmentEdit.landCode);
        setLocationLotNumberValue(apartmentEdit.locationLotNumber);
        setGroundValue(apartmentEdit.ground);
        setRealEstateValue(apartmentEdit.realEstate);
        setSiteRightLandCodeValue(apartmentEdit.siteRightLandCode);
        setSiteRightTypeValue(apartmentEdit.siteRightType);
        setSiteRightPercentageValue(apartmentEdit.siteRightPercentage);
        setTargetPersonValue(index);
        setInheritanceBequestValue(apartmentEdit.inheritanceBequest);

        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });

        dispatch(clearApartment(index));
    }

    const handleApartmentDelete = (index, event) => {
        dispatch(clearApartment(index));
        setOpen(false);
    }

    const [whereaboutsHelperText, whereaboutsHelper] = useState('必須');
    const [buildingNameHelperText, buildingNameHelper] = useState('必須');
    const [houseNumber1HelperText, houseNumber1Helper] = useState('必須');
//    const [houseNumberHelperText, houseNumberHelper] = useState('必須');
    const [proprietaryPartBuildingNameHelperText, proprietaryPartBuildingNameHelper] = useState('必須');
    const [typeHelperText, typeHelper] = useState('必須');
    const [constructionHelperText, constructionHelper] = useState('必須');
    const [floorSpaceHelperText, floorSpaceHelper] = useState('必須');
    const [landCodeHelperText, landCodeHelper] = useState('必須');
    const [locationLotNumberHelperText, locationLotNumberHelper] = useState('必須');
    const [groundHelperText, groundHelper] = useState('必須');
    const [realEstateHelperText, realEstateHelper] = useState('必須');
    const [siteRightLandCodeHelperText, siteRightLandCodeHelper] = useState('必須');
    const [siteRightTypeHelperText, siteRightTypeHelper] = useState('必須');
    const [siteRightPercentageHelperText, siteRightPercentageHelper] = useState('必須');
    const [targetPersonHelperText, targetPersonHelper] = useState('必須');
    const [inheritanceBequestHelperText, inheritanceBequestHelper] = useState('必須');

    const [whereaboutsValidate, checkWhereabouts] = useState(false);
    const handleWhereabouts = (event) => {
        if(event.target.value){
            checkWhereabouts(false);
            whereaboutsHelper('必須');
            setWhereaboutsValue(event.target.value);
        }else{
            checkWhereabouts(true);
            whereaboutsHelper('所在は必ずご入力くさだい。');
            setWhereaboutsValue(null);
        }
    }

    const [buildingNameValidate, checkBuildingName] = useState(false);
    const handleBuildingName = (event) => {
        if(event.target.value){
            checkBuildingName(false);
            buildingNameHelper('必須');
            setBuildingNameValue(event.target.value);
        }else{
            checkBuildingName(true);
            buildingNameHelper('建物の名称は必ずご入力くさだい。');
            setBuildingNameValue(null);
        }
    }

    const [houseNumber1Validate, checkHouseNumber1] = useState(false);
    const handleHouseNumber1 = (event) => {
        if(event.target.value){
            checkHouseNumber1(false);
            houseNumber1Helper('必須');
            setHouseNumber1Value(event.target.value);
        }else{
            checkHouseNumber1(true);
            houseNumber1Helper('家屋番号は必ずご入力くさだい。');
            setHouseNumber1Value(null);
        }
    }

//    const [houseNumberValidate, checkHouseNumber] = useState(false);
//    const handleHouseNumber = (event) => {
//        if(event.target.value){
//            checkHouseNumber(false);
//            houseNumberHelper('必須');
//            setHouseNumberValue(event.target.value);
//        }else{
//            checkHouseNumber(true);
//            houseNumberHelper('家屋番号は必ずご入力くさだい。');
//            setHouseNumberValue(null);
//        }
//    }

    const [proprietaryPartBuildingName, checkProprietaryPartBuildingName] = useState(false);
    const handleProprietaryPartBuildingName = (event) => {
        if(event.target.value){
            checkProprietaryPartBuildingName(false);
            proprietaryPartBuildingNameHelper('必須');
            setProprietaryPartBuildingNameValue(event.target.value);
        }else{
            checkProprietaryPartBuildingName(true);
            proprietaryPartBuildingNameHelper('建物の名称は必ずご入力くさだい。');
            setProprietaryPartBuildingNameValue(null);
        }
    }

    const [typeValidate, checkType] = useState(false);
    const handleType = (event) => {
        if(event.target.value){
            checkType(false);
            typeHelper('必須');
            setTypeValue(event.target.value);
        }else{
            checkType(true);
            typeHelper('種類は必ずご入力くさだい。');
            setTypeValue(null);
        }
    }

    const [constructionValidate, checkConstruction] = useState(false);
    const handleConstruction = (event) => {
        if(event.target.value){
            checkConstruction(false);
            constructionHelper('必須');
            setConstructionValue(event.target.value);
        }else{
            checkConstruction(true);
            constructionHelper('構造は必ずご入力くさだい。');
            setConstructionValue(null);
        }
    }

    const [floorSpaceValidate, checkFloorSpace] = useState(false);
    const handleFloorSpace = (event) => {
        if(event.target.value){
            checkFloorSpace(false);
            floorSpaceHelper('必須');
            setFloorSpaceValue(event.target.value);
        }else{
            checkFloorSpace(true);
            floorSpaceHelper('床面積は必ずご入力くさだい。');
            setFloorSpaceValue(null);
        }
    }

    const [landCodeValidate, checkLandCode] = useState(false);
    const handleLandCode = (event) => {
        if(event.target.value){
            checkLandCode(false);
            landCodeHelper('必須');
            setLandCodeValue(event.target.value);
        }else{
            checkLandCode(true);
            landCodeHelper('土地の符号は必ずご入力くさだい。');
            setLandCodeValue(null);
        }
    }

    const [locationLotNumberValidate, checkLocationLotNumber] = useState(false);
    const handleLocationLotNumber = (event) => {
        if(event.target.value){
            checkLocationLotNumber(false);
            locationLotNumberHelper('必須');
            setLocationLotNumberValue(event.target.value);
        }else{
            checkLocationLotNumber(true);
            locationLotNumberHelper('所在地及び地番は必ずご入力くさだい。');
            setLocationLotNumberValue(null);
        }
    }

    const [groundValidate, checkGround] = useState(false);
    const handleGround = (event) => {
        if(event.target.value){
            checkGround(false);
            groundHelper('必須');
            setGroundValue(event.target.value);
        }else{
            checkGround(true);
            groundHelper('地目は必ずご入力くさだい。');
            setGroundValue(null);
        }
    }

    const [realEstateValidate, checkRealEstate] = useState(false);
    const handleRealEstate = (event) => {
        if(event.target.value){
            checkRealEstate(false);
            realEstateHelper('必須');
            setRealEstateValue(event.target.value);
        }else{
            checkRealEstate(true);
            realEstateHelper('地積は必ずご入力くさだい。');
            setRealEstateValue(null);
        }
    }

    const [siteRightLandCodeValidate, checkSiteRightLandCode] = useState(false);
    const handleSiteRightLandCode = (event) => {
        if(event.target.value){
            checkSiteRightLandCode(false);
            siteRightLandCodeHelper('必須');
            setSiteRightLandCodeValue(event.target.value);
        }else{
            checkSiteRightLandCode(true);
            siteRightLandCodeHelper('土地の符号は必ずご入力くさだい。');
            setSiteRightLandCodeValue(null);
        }
    }

    const [siteRightTypeValidate, checkSiteRightType] = useState(false);
    const handleSiteRightType = (event) => {
        if(event.target.value){
            checkSiteRightType(false);
            siteRightTypeHelper('必須');
            setSiteRightTypeValue(event.target.value);
        }else{
            checkSiteRightType(true);
            siteRightTypeHelper('敷地権の種類は必ずご入力くさだい。');
            setSiteRightTypeValue(null);
        }
    }

    const [siteRightPercentageValidate, checkSiteRightPercentage] = useState(false);
    const handleSiteRightPercentage = (event) => {
        if(event.target.value){
            checkSiteRightPercentage(false);
            siteRightPercentageHelper('必須');
            setSiteRightPercentageValue(event.target.value);
        }else{
            checkSiteRightPercentage(true);
            siteRightPercentageHelper('敷地権の割合は必ずご入力くさだい。');
            setSiteRightPercentageValue(null);
        }
    }

    const [targetPersonValidate, checkTargetPerson] = useState(false);
    const handleTargetPerson = (event) => {
        if(event.target.value != null){
            checkTargetPerson(false);
            targetPersonHelper('必須');
            setTargetPersonValue(event.target.value);
        }else{
            checkTargetPerson(true);
            targetPersonHelper('取得対象者は必ずご入力くさだい。');
            setTargetPersonValue(null);
        }
    }

    const [inheritanceBequestValidate, checkInheritanceBequest] = useState(false);
    const handleInheritanceBequest = (event) => {
        if(event.target.value){
            checkInheritanceBequest(false);
            inheritanceBequestHelper('必須');
            setInheritanceBequestValue(event.target.value);
        }else{
            checkInheritanceBequest(true);
            inheritanceBequestHelper('相続・遺贈は必ずご入力くさだい。');
            setInheritanceBequestValue(null);
        }
    }

    const [deleteTargetIndex, deleteTarget] = useState(null);

    const [open, setOpen] = useState(false);

    const handleDialogOpen = (index) => {
        setOpen(true);
        deleteTarget(index);
    }

    const handleDialogClose = () => {
        setOpen(false);
    }

    const classes = useStyles();

    return(
        <Container>
            <Grid container spacing={3}>
                <Grid item xs={12} lg={6}>
                    <PageExplanation pageName="不動産(マンション等)" firstItemName="所在" igonFlag={igonFlag}/>

                    <PageStep activeStep={1}/>

                    <PropertyStep activeStep={0} nowPage="apartment"/>

                    <MenuList pageName="不動産(マンション等)" />

                    <Typography>
                        一棟の建物の表示
                    </Typography>
                    <TextField
                        id="apartment_whereabouts"
                        name="apartment_whereabouts"
                        label="所在"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="所在をご入力ください。"
                        helperText={whereaboutsHelperText}
                        fullWidth
                        margin="normal"
                        InputProps={{
                            required: true,
                            startAdornment: <InputAdornment position="start" className={classes.number}>①</InputAdornment>
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleWhereabouts}
                        onChange={handleWhereabouts}
                        error={whereaboutsValidate}
                        value={whereaboutsValue}
                    />
                    <TextField
                        id="apartment_building_name"
                        name="apartment_building_name"
                        label="建物の名称"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="建物の名称をご入力ください。"
                        helperText={buildingNameHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleBuildingName}
                        onChange={handleBuildingName}
                        error={buildingNameValidate}
                        value={buildingNameValue}
                    />
                    <Typography>
                        専有部分の建物の表示
                    </Typography>
                    <Box>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <FormControl className={classes.text} fullWidth>
                                    <InputLabel shrink={true} htmlFor="apartment_house_number_1">家屋番号</InputLabel>
                                    <Input
                                        fullWidth
                                        id="apartment_house_number_1"
                                        name="apartment_house_number_1"
                                        placeholder="家屋番号をご入力ください。"
                                        startAdornment={<InputAdornment position="start" className={classes.number}>②</InputAdornment>}
                                        endAdornment={<InputAdornment position="end">番</InputAdornment>}
                                        onKeyUp={handleHouseNumber1}
                                        onChange={handleHouseNumber1}
                                        error={houseNumber1Validate}
                                        value={houseNumber1Value}
                                    />
                                    <FormHelperText className={classes.requiredHelper}>{houseNumber1HelperText}</FormHelperText>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box>
                    <TextField
                        id="apartment_proprietary_part_building_name"
                        name="apartment_proprietary_part_building_name"
                        label="建物の名称"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="建物の名称をご入力ください。"
                        helperText={proprietaryPartBuildingNameHelperText}
                        fullWidth
                        margin="normal"
                        InputProps={{
                            required: true,
                            startAdornment: <InputAdornment position="start" className={classes.number}>③</InputAdornment>
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleProprietaryPartBuildingName}
                        onChange={handleProprietaryPartBuildingName}
                        error={proprietaryPartBuildingName}
                        value={proprietaryPartBuildingNameValue}
                    />
                    <TextField
                        id="apartment_type"
                        name="apartment_type"
                        label="種類"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="種類をご入力ください。"
                        helperText={typeHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleType}
                        onChange={handleType}
                        error={typeValidate}
                        value={typeValue}
                    />
                    <TextField
                        id="apartment_construction"
                        name="apartment_construction"
                        label="構造"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="構造をご入力ください。"
                        helperText={constructionHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleConstruction}
                        onChange={handleConstruction}
                        error={constructionValidate}
                        value={constructionValue}
                    />
                    </Box>
                    <Box>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <FormControl className={classes.text} fullWidth>
                                    <InputLabel shrink={true} htmlFor="apartment_floor_space_1">床面積</InputLabel>
                                    <Input
                                        fullWidth
                                        id="apartment_floor_space_1"
                                        endAdornment={<InputAdornment position="end">平方米</InputAdornment>}
                                        onKeyUp={handleFloorSpace}
                                        onChange={handleFloorSpace}
                                        error={floorSpaceValidate}
                                        value={floorSpaceValue}
                                    />
                                    <FormHelperText className={classes.requiredHelper}>{floorSpaceHelperText}</FormHelperText>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Box>
                    <Typography>
                        敷地権の目的たる土地の表示
                    </Typography>
                    <TextField
                        id="apartment_land_code"
                        name="apartment_land_code"
                        label="土地の符号"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="土地の符号をご入力ください。"
                        helperText={landCodeHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleLandCode}
                        onChange={handleLandCode}
                        error={landCodeValidate}
                        value={landCodeValue}
                    />
                    <TextField
                        id="apartment_location_lot_number"
                        name="apartment_location_lot_number"
                        label="所在地及び地番"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="所在地及び地番をご入力ください。"
                        helperText={locationLotNumberHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleLocationLotNumber}
                        onChange={handleLocationLotNumber}
                        error={locationLotNumberValidate}
                        value={locationLotNumberValue}
                    />
                    <TextField
                        id="apartment_ground"
                        name="apartment_ground"
                        label="地目"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="地目"
                        helperText={groundHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleGround}
                        onChange={handleGround}
                        error={groundValidate}
                        value={groundValue}
                    />
                    <TextField
                        id="apartment_real_estate"
                        name="apartment_real_estate"
                        label="地積"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="地積をご入力ください。"
                        helperText={realEstateHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleRealEstate}
                        onChange={handleRealEstate}
                        error={realEstateValidate}
                        value={realEstateValue}
                    />
                    <Typography>
                        敷地権の目的たる土地の表示
                    </Typography>
                    <TextField
                        id="apartment_site_right_land_code"
                        name="apartment_site_right_land_code"
                        label="土地の符号"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="土地の符号をご入力ください。"
                        helperText={siteRightLandCodeHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleSiteRightLandCode}
                        onChange={handleSiteRightLandCode}
                        error={siteRightLandCodeValidate}
                        value={siteRightLandCodeValue}
                    />
                    <TextField
                        id="apartment_site_right_type"
                        name="apartment_site_right_type"
                        label="敷地権の種類"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="敷地権の種類をご入力ください。"
                        helperText={siteRightTypeHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleSiteRightType}
                        onChange={handleSiteRightType}
                        error={siteRightTypeValidate}
                        value={siteRightTypeValue}
                    />
                    <TextField
                        id="apartment_site_right_percentage"
                        name="apartment_site_right_percentage"
                        label="敷地権の割合"
                        style={{ margin: 8 }}
                        className={classes.required}
                        placeholder="敷地権の割合をご入力ください。"
                        helperText={siteRightPercentageHelperText}
                        fullWidth
                        margin="normal"
                        inputProps={{
                            required: true,
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onKeyUp={handleSiteRightPercentage}
                        onChange={handleSiteRightPercentage}
                        error={siteRightPercentageValidate}
                        value={siteRightPercentageValue}
                    />
                    <TargetPerson targetPersonId="apartment_target_person" targetPersonName="apartment_target_person" targetPersonValue={targetPersonValue} targetPersonHelperText={targetPersonHelperText} targetPersonValidate={targetPersonValidate} handleTargetPerson={handleTargetPerson}/>
                    <InheritanceBequest inheritanceBequestId="apartment_inheritance_bequest" inheritanceBequestName="apartment_inheritance_bequest" inheritanceBequestHelperText={inheritanceBequestHelperText} handleInheritanceBequest={handleInheritanceBequest} inheritanceBequestValidate={inheritanceBequestValidate} inheritanceBequestValue={inheritanceBequestValue}/>

                    <Explanation/>

                    <Paper className={classes.listWrap}>
                        <Toolbar>
                            <Typography variant="h6">今入力されている不動産(マンション等)の一覧</Typography>
                        </Toolbar>
                            {
                                (()=>{
                                    if(apartment.length){
                                        return (
                                            <>
                                            <Hidden smDown>
                                                <TableContainer component={Paper} className={classes.list}>
                                                    <Table size="small">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell className={classes.head}>財産番号</TableCell>
                                                                <TableCell className={classes.head}>所在</TableCell>
                                                                <TableCell className={classes.head}>建物の名称</TableCell>
                                                                <TableCell className={classes.head}>&nbsp;</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                        {apartment.map((row, index) => {
                                                            return (
                                                                <TableRow hover>
                                                                    <TableCell>不動産(マンション等)({index+1})</TableCell>
                                                                    <TableCell>{row.whereabouts}</TableCell>
                                                                    <TableCell>{row.buildingName}</TableCell>
                                                                    <TableCell>
                                                                        <Button
                                                                            variant="contained"
                                                                            color="default"
                                                                            style={{ margin: 8 }}
                                                                            onClick={(event) => { handleApartmentEdit(index, event) }}
                                                                            startIcon={<EditIcon/>}
                                                                            className={classes.operating}
                                                                        >
                                                                        編集
                                                                        </Button>
                                                                        <Button
                                                                            variant="contained"
                                                                            color="default"
                                                                            style={{ margin: 8 }}
                                                                            onClick={(event) => { handleDialogOpen(index) }}
                                                                            startIcon={<DeleteIcon/>}
                                                                            className={classes.operating}
                                                                        >
                                                                        削除
                                                                        </Button>
                                                                    </TableCell>
                                                                </TableRow>
                                                            );
                                                        })}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Hidden>

                                            <Hidden mdUp>
                                                <TableContainer component={Paper} className={classes.list}>
                                                    <Table size="small">
                                                        {apartment.map((row, index) => {
                                                            return (
                                                                <>
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell className={classes.head} colspan={2}>財産番号&nbsp;不動産(マンション等)({index+1})</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    <TableRow hover>
                                                                        <TableCell>所在</TableCell>
                                                                        <TableCell>{row.whereabouts}</TableCell>
                                                                    </TableRow>
                                                                    <TableRow hover>
                                                                        <TableCell>建物の名称</TableCell>
                                                                        <TableCell>{row.buildingName}</TableCell>
                                                                    </TableRow>
                                                                    <TableRow hover>
                                                                        <TableCell colspan={2} className={classes.center}>
                                                                            <Button
                                                                                variant="contained"
                                                                                color="default"
                                                                                style={{ margin: 8 }}
                                                                                onClick={(event) => { handleApartmentEdit(index, event) }}
                                                                                startIcon={<EditIcon/>}
                                                                                className={classes.operating}
                                                                            >
                                                                            編集
                                                                            </Button>
                                                                            <Button
                                                                                variant="contained"
                                                                                color="default"
                                                                                style={{ margin: 8 }}
                                                                                onClick={(event) => { handleDialogOpen(index) }}
                                                                                startIcon={<DeleteIcon/>}
                                                                                className={classes.operating}
                                                                            >
                                                                            削除
                                                                            </Button>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                </TableBody>
                                                                </>
                                                            );
                                                        })}
                                                    </Table>
                                                </TableContainer>
                                            </Hidden>
                                            </>
                                        );
                                    }else{
                                        return (
                                            <>
                                            <Hidden smDown>
                                            <TableContainer component={Paper} className={classes.list}>
                                                <Table size="small">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell className={classes.head}>財産番号</TableCell>
                                                            <TableCell className={classes.head}>所在</TableCell>
                                                            <TableCell className={classes.head}>建物の名称</TableCell>
                                                            <TableCell className={classes.head}>&nbsp;</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        <TableRow hover>
                                                            <TableCell colSpan={4}><Typography>入力している不動産(マンション等)の情報はありません</Typography></TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                            </Hidden>

                                            <Hidden mdUp>
                                                <TableContainer component={Paper} className={classes.list}>
                                                    <Table size="small">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell className={classes.head} colspan={2}>不動産(マンション等)番号</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            <TableRow hover>
                                                                <TableCell>所在</TableCell>
                                                                <TableCell rowspan={2}>入力している不動産(マンション等)の<br/>情報はありません</TableCell>
                                                            </TableRow>
                                                            <TableRow hover>
                                                                <TableCell>建物の名称</TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Hidden>
                                            </>
                                        );
                                    }
                                })()
                            }
                    </Paper>

                    <Dialog
                        open={open}
                        onClose={handleDialogClose}
                    >
                        <DialogTitle>{"削除確認"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                削除します。よろしいですか?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleDialogClose} color="dafalut">
                                いいえ
                            </Button>
                            <Button onClick={() => { handleApartmentDelete(deleteTargetIndex) }} color="secondary">
                                はい
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <PropertyMenu execute={handleApartment} message={error}/>
                </Grid>
                <Grid item xs={12} lg={6}>
                    <FlowTitle title="財産目録の作成の流れをご説明します。【不動産(マンション)】" />
                    <FlowItem image="img/icon_list.png" contents="①不動産（マンション）を入力します。<br>不動産登記簿謄本に元に必要項目を入力します。" />
                    <FlowArrow/>
                    <img src="img/tokibo2.png"/>
                    <FlowArrow/>
                    <FlowItem image="img/icon_money.png" contents="②固定資産税評価額を入力<br>固定資産税評価額の資料を確認し入力します。" />
                    <FlowArrow/>
                    <FlowItem image="img/icon_person.png" contents="③この財産の取得対象者を入力します。<br>取得対象者の姓名を正確に入力します。" />
                    <FlowArrow/>
                    <FlowItem image="img/icon_check.png" contents="④相続・遺贈を入力します。<br>相続とは、財産を法定相続人が引き継ぐことです。法定相続人以外の者に、「相続させる」ことはできません。<br>遺贈とは、遺言によって、無償で財産を譲与することです。<br>法定相続人には、遺贈ではなく「相続させる」方が、課税や手続などの面で有利な場合が多いと考えられています。" />
                    <FlowArrow/>
                    <FlowItem image="img/icon_list.png" contents="⑤他の財産を入力する。<br>「メニューから保有する財産を選ぶ」をクリックし、メニューの中<br>から入力したい財産を選んで入力します。" />
                    <GuideHalf pageName="不動産(マンション等)"/>
                </Grid>
            </Grid>

        </Container>
    );
}

export default Apartment
